export const convertStringToArray = (string: any) => {
    const arr = string.split(',');
    return arr.map((name: any, index: any) => ({
      name,
      id: (index + 1).toString(),
      check_status: false
    }));
  };